import { Popup } from "@/components/Popup";
import { importIcon } from "@/designSystemIcons";
import { IOS_CLUB_IMPORT_APP_URL } from "@/settings";

interface IosImportPopupProps {
  onClose: () => void;
}
export const IosImportPopup = ({ onClose }: IosImportPopupProps) => {
  return (
    <Popup
      title="Mobile Club Import"
      onClose={onClose}
      actionTitle="Download Extension"
      titleIcon={importIcon}
      handleActionClicked={() => {
        window.open(IOS_CLUB_IMPORT_APP_URL, "_blank");
      }}
    >
      <div
        className="w-84 small-mobile:w-100 px-6 pt-8 flex flex-col items-center mx-auto gap-y-10 "
        style={{
          background:
            "radial-gradient(46.03% 45.98% at 37% 31.14%, #085271 0%, rgba(8, 82, 113, 0.00) 100%)",
        }}
      >
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/my-club/mobile-club-import/hero-image.png"
          }
          alt="Mobile Club Import"
          className="h-20"
        />
        <p>
          Club Import is now available for iOS devices! Get the extension for
          Safari (iOS) to get started.
        </p>
      </div>
    </Popup>
  );
};
